import React, { Component } from 'react'

const AutocompleteHOC = WrappedComponent => {
  return class extends Component {
    state = {
      value: '',
      suggestions: []
    }

    changeHandler = (event, { newValue }) => {
      this.setState({
        value: newValue
      })
    }

    setValue = value => {
      this.setState({ value: value })
    }

    setSuggestions = suggestions => {
      this.setState({ suggestions: suggestions })
    }

    onSuggestionsClearRequested = () => {
      this.setState({
        suggestions: []
      })
    }

    clearHandler = () => {
      this.setState({ value: '' })
    }

    render() {
      const props = {
        ...this.props,
        state: this.state,
        changeHandler: this.changeHandler,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        setValue: this.setValue,
        setSuggestions: this.setSuggestions,
        clearHandler: this.clearHandler
      }

      return <WrappedComponent {...props} />
    }
  }
}

export default AutocompleteHOC



// WEBPACK FOOTER //
// ./src/hocs/AutocompleteHOC/index.js